import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M12.36 12.34a16.44 16.44 0 0 1 16.7 -4 2.5 2.5 0 1 0 1.52 -4.76A21.5 21.5 0 0 0 4.1 32a0.5 0.5 0 0 1 -0.2 0.6l-2.8 1.86a2 2 0 0 0 -0.86 2 2 2 0 0 0 1.56 1.58l8.82 1.96 0.4 0a2 2 0 0 0 1.1 -0.34 2 2 0 0 0 0.86 -1.26l1.82 -8.82a2 2 0 0 0 -0.84 -2 2 2 0 0 0 -2.22 0l-2.68 1.76a0.58 0.58 0 0 1 -0.44 0 0.56 0.56 0 0 1 -0.32 -0.32 16.56 16.56 0 0 1 4.06 -16.68Z",
        fill: "currentColor",
        "stroke-width": "2"
      }),
      _createElementVNode("path", {
        d: "M47.76 11.66a2 2 0 0 0 -1.52 -1.6L37.46 8a2 2 0 0 0 -2.4 1.5l-2 8.76a2 2 0 0 0 0.8 2 2 2 0 0 0 1.16 0.38 1.88 1.88 0 0 0 1.06 -0.32l2.88 -1.8a0.58 0.58 0 0 1 0.44 0 0.56 0.56 0 0 1 0.32 0.32A16.5 16.5 0 0 1 19.14 39.76a2.5 2.5 0 0 0 -3.14 1.66 2.48 2.48 0 0 0 1.64 3.12 21.2 21.2 0 0 0 6.38 0.96A21.5 21.5 0 0 0 44 16a0.54 0.54 0 0 1 0.2 -0.62l2.7 -1.68a2 2 0 0 0 0.86 -2.04Z",
        fill: "currentColor",
        "stroke-width": "2"
      })
    ], -1)
  ])))
}
export default { render: render }